import { Injectable } from '@angular/core';
import jwtEncode from 'jwt-encode';

@Injectable({
  providedIn: 'root'
})

export class JwtService {

  constructor() { }

  encode(payload: object, secret: string): string {
    return jwtEncode(payload, secret);
  }

}